// Produtos personalizados mantêm o preço configurado; os demais usam o preço vigente (promoção ativa ou preço normal)
export const currentUnitPrice = (product, cartItem) => {
  const customized = product.is_customizable || product.free_dimensions_enabled;
  if (customized && cartItem?.custom_price) return cartItem.custom_price;
  return product.promotional_price || product.price;
};
